// extracted by mini-css-extract-plugin
export default {"container":"text_container__2Aicy","hasErrors":"text_hasErrors__3KpeS"};